import { render, staticRenderFns } from "./AccountingClosedPeriods.vue?vue&type=template&id=416de729&scoped=true"
import script from "./AccountingClosedPeriods.vue?vue&type=script&lang=ts"
export * from "./AccountingClosedPeriods.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416de729",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('416de729')) {
      api.createRecord('416de729', component.options)
    } else {
      api.reload('416de729', component.options)
    }
    module.hot.accept("./AccountingClosedPeriods.vue?vue&type=template&id=416de729&scoped=true", function () {
      api.rerender('416de729', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/AccountingClosedPeriods.vue"
export default component.exports